import { addBreadcrumb, captureException } from '@sentry/browser'
import { setAlertBagError } from '../../../../rx/store/AlertBag'
import { deepClone } from '../../../deep_clone'
import { getEngineAlertBag } from '../../../three/fn/getSetEngineAlertBag'
import { getEngineToast } from '../../../three/fn/getSetEngineToast'
import { Engine } from '../../engine/Engine.type'
import Action from './action/Action.type'
import type { ActionLog } from './ActionLog.type'
import { useEnginePrevStateSignal } from '../../../../rx/signal/useEnginePrevStateSignal'
import applyActionWithWasm from './applyActionWithWasm'

// let lastClientDispatch: Promise<unknown> | null = null
export default async function dispatchFromRemote(engine: Engine, action: Action, expectedActionLog : ActionLog): Promise<void> {
  // console.log('dispatchFromRemote', action)
  addBreadcrumb({
    category: 'action',
    level: 'info',
    data: {
      action,
    },
  })
  try {
    await applyActionWithWasm(engine, action)
    const [, setPrevState] = useEnginePrevStateSignal(engine)
    setPrevState(deepClone(engine.state))
  } catch (err) {
    const toast = getEngineToast(engine)
    const ab = getEngineAlertBag(engine)
    const msg: string = (err as { message?: string }).message || 'unknown'
    const context: Record<string, unknown> = {
      action,
      expectedActionLog,
    }
    console.error(err, context)
    captureException(err, context)
    if (toast) {
      toast.error(msg)
    }
    if (ab) {
      setAlertBagError(ab, err as Error)
    }
    throw err
  }
}
